'use client';

import { useEffect } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { TOKEN_EXPIRY_TIME } from '@/constants';

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'
    )
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

function setCookie(name: string, value: string, maxAge?: number) {
  let cookie = `${name}=${encodeURIComponent(value)}; path=/`;
  if (maxAge !== undefined) {
    cookie += `; max-age=${maxAge}`;
  }
  document.cookie = cookie;
}

export default function CookieInitializer() {
  useEffect(() => {
    let userId = getCookie('user-id');

    if (!userId) {
      userId = uuidV4();
      setCookie('user-id', userId, TOKEN_EXPIRY_TIME);
    }

    if (!getCookie('wizzy_sessionId')) {
      setCookie('wizzy_sessionId', uuidV4());
    }

    if (!getCookie('wizzy_userId')) {
      setCookie('wizzy_userId', userId);
    }
  }, []);

  return null;
}
